import * as React from 'react';
import {Controller} from 'react-hook-form';
import {IInputSelect} from '../types/dataForm/types';
import get from 'lodash/get';
import {FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField} from '@mui/material';
import {debounce} from 'lodash';

interface InputSelectProps extends IInputSelect {
  name: string;
  form: any;
  options: any;
  label: string;
  entries?: Array<[string, string]> | any;
  mb: any;
}

export default function InputSelect(props: InputSelectProps) {
  const {name, form, options, label, entries, mb = 0} = props;

  return (
    <Controller
      name={name}
      control={form.control}
      defaultValue=""
      render={({field: {onChange, value}, fieldState: {error}}) => {
        const hasError = !!error;
        return (
          <FormControl fullWidth error={hasError} sx={{mb}}>
            <InputLabel shrink={true}>{label}</InputLabel>
            <Select size="small" onChange={onChange} value={value} label={label} error={hasError} variant="outlined">
              {options?.map((option: any) => (
                <MenuItem key={get(option, entries[0])} value={get(option, entries[0])}>
                  {get(option, entries[1])}
                </MenuItem>
              ))}
            </Select>
            {hasError && <FormHelperText>{error.message}</FormHelperText>}
          </FormControl>
        );
      }}
    />
  );
}
